// extracted by mini-css-extract-plugin
export default {"breadcrumb":"breadcrumb--jdrCHACx20","arrow":"arrow--lv7hi+9eWz"};